export default __webpack_public_path__ + "/dist/images/lets-start.e54125a4b7ea0b8f4bd92b51d3e0772d.png";